<template>
  <div class="usermanagetable">
    <el-table :data="tableData" style="width: 100%;padding:10px 10px 0 10px;" border>
      <el-table-column prop="createAtMY" label="创建时间" width="120"></el-table-column>
      <el-table-column prop="title" label="主题名称"></el-table-column>
      <el-table-column prop="theme" label="模板名称"></el-table-column>
      <el-table-column prop="status" label="状态" width="65">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 1">
            <el-tag type="success">{{'启用'}}</el-tag>
          </div>

          <div v-if="scope.row.status === 0">
            <el-tag type="danger">{{'禁用'}}</el-tag>
          </div>

          <div v-if="scope.row.status !== 0 && scope.row.status !== 1">
            <el-tag type="info">{{'无'}}</el-tag>
          </div>
          <!-- <span
            :style="{'color':scope.row.status === 1 ? 'red' : '#606266'}"
          >{{scope.row.status === 0 ? '开启' : '停用'}}</span> -->
        </template>
      </el-table-column>

      <el-table-column label="操作" width="350">
        <template slot-scope="scope">
          
          <el-button @click="closeClick(scope)" v-if="scope.row.status === 1" style="color:#F96900;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-circle-close"></i>禁用</el-button>
          <el-button @click="closeClick(scope)" v-if="scope.row.status !== 1" style="color:#13aa65;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-document-checked"></i>启用</el-button>
          <span style="margin:0 11px;" v-if="scope.row.id !== 60000">|</span>
          <el-button @click="changeClick(scope)" style="color:#185ED3;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-edit-outline"></i>修改</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import {userTabletype,userTablemode} from '@/constants/tablecommon'
import { listAuthRole } from "@/api/authRole";
export default {
  name: "usermanagetable",
  props: {
    tableData: Array
  },
  data() {
    return {
      // userTabletype,
      // userTablemode,
      // tableData:[
        // {
        //   createMy:'2020-06-22',
        //   name:'默认主题-红色',
        //   moblie:'default-red',
        //   status:0
        // },
        // {
        //   createMy:'2020-06-22',
        //   name:'默认主题-黑色',
        //   moblie:'default-black',
        //   status:1
        // },{
        //   createMy:'2020-06-22',
        //   name:'默认主题-蓝色',
        //   moblie:'default-blue',
        //   status:0
        // },
      // ]
    };
  },
  methods: {
    changeClick(scope) {
      this.$emit("changeClick", scope);
    },
    removeClick(scope) {
      this.$emit("removeClick", scope);
    },
    closeClick(scope) {
      this.$emit("closeClick", scope);
    },

  },
  created() {
    // this.listAuthRoleAsync()
    
  },
  mounted(){
    // console.log(this.tableData)
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.active {
  color: red;
}
.btn:hover{
  text-decoration: underline;
}
</style>
